/**
 * Microsite card pricing: compare-at strikethrough for block cards.
 */
(function () {
  function formatMoney(cents) {
    try {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        var format =
          (window.theme && window.theme.moneyFormat) ||
          (typeof theme !== 'undefined' && theme.moneyFormat) ||
          '${{amount}}';
        return Shopify.formatMoney(cents, format);
      }
    } catch (e) {
      /* ignore */
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function renderCompareMarkup(compareDollars, saleDollars) {
    return (
      '<span class="price price-compare"><del style="text-decoration:line-through!important;-webkit-text-decoration:line-through!important">' +
      '$' +
      compareDollars.toFixed(2) +
      '</del></span>' +
      '<span class="price price-sale">$' +
      saleDollars.toFixed(2) +
      '</span>'
    );
  }

  function parseFallbackTag(tag) {
    if (!tag) return null;
    var cleaned = tag.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    var nums = cleaned.match(/(\d+(?:\.\d{1,2})?)/g);
    if (!nums || nums.length < 2) return null;
    var a = parseFloat(nums[0]);
    var b = parseFloat(nums[1]);
    if (!(a > 0 && b > 0) || a === b) return null;
    return {
      compare: Math.max(a, b),
      sale: Math.min(a, b),
    };
  }

  function applyParsedFallback(el) {
    var tag = el.getAttribute('data-fallback-tag') || '';
    var parsed = parseFallbackTag(tag);
    if (!parsed) return false;
    el.innerHTML = renderCompareMarkup(parsed.compare, parsed.sale);
    el.dataset.hydrated = '1';
    return true;
  }

  function renderFromVariant(el, variant) {
    var compare = variant.compare_at_price;
    var price = variant.price;
    if (compare && compare > price) {
      el.innerHTML = renderCompareMarkup(compare / 100, price / 100);
    } else {
      el.innerHTML = '<span class="price price-sale">' + formatMoney(price) + '</span>';
    }
    el.dataset.hydrated = '1';
  }

  function hydrateMicrositePrices(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('.microsite-price--hydrate[data-variant-id]');

    nodes.forEach(function (el) {
      if (el.dataset.hydrated === '1') return;

      if (applyParsedFallback(el)) return;

      var id = el.getAttribute('data-variant-id');
      if (!id) return;

      fetch('/variants/' + id + '.js', { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('variant ' + id);
          return res.json();
        })
        .then(function (variant) {
          renderFromVariant(el, variant);
        })
        .catch(function () {
          applyParsedFallback(el);
        });
    });
  }

  hydrateMicrositePrices();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      hydrateMicrositePrices();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    hydrateMicrositePrices(event.target);
  });
})();
